module.exports = __webpack_public_path__ + "img/home_city_icon2.cadc860.png";